import api from "./api";
import { ConnectionState, InvoiceMappingField } from "../types";

export interface IntegrationStatus {
  xero: ConnectionState;
  jobber: ConnectionState;
}

export interface InvoiceMappingStrategy {
  prefix: string;
  field: InvoiceMappingField;
}

export function getIntegrationStatus(state: string|null) {
  return api.get("/status/integration", {
    headers: {
      'X-INTEGRATION-STATE': state,
    }
  });
}

export function reauthorizeJobber(code: string|null, state: string|null) {
  return api.post("/jobber/reauthorize", {}, {
    headers: {
      'X-JOBBER-CODE': code,
      'X-INTEGRATION-STATE': state,
    }
  });
}

export function getInvoiceMappingStrategy(state: string|null) {
  return api.get("/invoices/mapping_strategy", {
    headers: {
      'X-INTEGRATION-STATE': state,
    }
  });
}

export function updateInvoiceMappingStrategy(strategy: InvoiceMappingStrategy, state: string|null) {
  return api.post("/invoices/mapping_strategy", strategy, {
    headers: {
      'X-INTEGRATION-STATE': state,
    }
  });
}
